import { render, staticRenderFns } from "./CallToTheHeartScoreboard.vue?vue&type=template&id=e3fe91c2&scoped=true&lang=pug"
import script from "./CallToTheHeartScoreboard.vue?vue&type=script&lang=ts"
export * from "./CallToTheHeartScoreboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fe91c2",
  null
  
)

export default component.exports